const DEFAULT_INITIAL_BACKOFF  = 1000 * 60;
const DEFAULT_MAX_BACKOFF = 1000 * 60 * 15;
const DEFAULT_RANDOMIZATION_FACTOR = 0.5;

export class FuzzingBackOffGenerator {
    private readonly randomizationFactor: number;
    private readonly initialBackOff: number;
    private readonly maxBackOff: number;
    private nextBackOffTime: number;
    private backOffTime: number;

    /**
     * @param initialBackOff Initial value to back off. Must be > 0
     * @param maxBackOff Max value to back off
     * @param randomisationFactor between 0 and 1 to control the range of randomness.
     */
    constructor(initialBackOff = DEFAULT_INITIAL_BACKOFF, maxBackOff = DEFAULT_MAX_BACKOFF, randomizationFactor = DEFAULT_RANDOMIZATION_FACTOR) {
        this.randomizationFactor = randomizationFactor;
        this.initialBackOff = initialBackOff;
        this.maxBackOff = maxBackOff;
        this.nextBackOffTime = initialBackOff;
        this.backOffTime = initialBackOff;
    }

    next() {
        let backOffTime = Math.min(this.nextBackOffTime, this.maxBackOff);
        this.nextBackOffTime += this.backOffTime;
        this.backOffTime = backOffTime;

        return this.backOffTime * (1.0 + (Math.random() * this.randomizationFactor));
    }

    reset() {
        this.nextBackOffTime = this.initialBackOff;
        this.backOffTime = this.initialBackOff;
    }

    // For unit tests
    getCurrent() {
        return this.backOffTime;
    }
}